import { Box, Button, MenuItem } from "@mui/material";
import { usePopover } from "../custom-popover";
import Iconify from "../iconify";
import { ISort } from "../../types/table";
import CustomPopover from "../custom-popover/custom-popover";

type Props = {
    direction: 'asc' | 'desc';
    sortBy: string;
    onSort: (direction: 'asc' | 'desc', sorBy: string) => void;
    sortOptions: ISort[];
}

const SortByComponent = ({ direction, sortBy, onSort, sortOptions } : Props) => {

    const popover = usePopover();

    return (
        <>
            <Button
                disableRipple
                color="inherit"
                onClick={popover.onOpen}
                endIcon={
                    <Iconify icon={popover.open ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"} />
                }
                sx={{ fontWeight: 'fontWeightSemiBold' }}
            >
                Ordenar Por:
                <Box
                    component="span"
                    sx={{
                        ml: 0.5,
                        fontWeight: 'fontWeightBold',
                        textTransform: 'capitalize'
                    }}
                >
                    {(sortOptions.find((sort: ISort) => sort.direction == direction && sort.sortBy == sortBy))?.label}
                </Box>
            </Button>

            <CustomPopover
                open={popover.open}
                onClose={popover.onClose}
                sx={{ width: 170 }}
            >
                {
                    sortOptions.map((option: ISort) => (
                        <MenuItem
                            key={option.direction + option.sortBy}
                            selected={option.direction == direction && option.sortBy == sortBy}
                            onClick={() => {
                                popover.onClose();
                                onSort(option.direction, option.sortBy);
                            }}
                        >
                            {option.label}
                        </MenuItem>
                    ))
                }
            </CustomPopover>
        </>
    );

}

export default SortByComponent;